import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f7f8fa',
        px: 2,
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: 'center',
            bgcolor: '#fff',
            borderRadius: 3,
            border: '1px solid #e8eaed',
            boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
            p: { xs: 4, md: 5 },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: '4rem', md: '5rem' },
              fontWeight: 800,
              color: '#FF0100',
              lineHeight: 1,
              mb: 1,
            }}
          >
            404
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1.5, color: '#0f1111' }}>
            Page not found
          </Typography>
          <Typography sx={{ color: '#565959', mb: 3, lineHeight: 1.7 }}>
            This page isn&apos;t available or may have moved. Head back to the homepage
            {isAuthenticated ? '' : ' and sign in'} to continue with Canadawale Yar.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              onClick={() => navigate('/')}
              sx={{
                bgcolor: '#FF0100',
                '&:hover': { bgcolor: '#CC0000' },
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
              }}
            >
              Go to homepage
            </Button>
            {!isAuthenticated && (
              <Button
                variant="outlined"
                onClick={() => navigate('/login')}
                sx={{
                  borderColor: '#d5d9d9',
                  color: '#0f1111',
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 3,
                }}
              >
                Sign in
              </Button>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
